import { render } from "./unlock.vue?vue&type=template&id=20050568&scoped=true"
import script from "./unlock.vue?vue&type=script&lang=js"
export * from "./unlock.vue?vue&type=script&lang=js"

import "./unlock.vue?vue&type=style&index=0&id=20050568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20050568"]])

export default __exports__